import { all } from 'redux-saga/effects';

import auth from './auth/sagas';
import statements from './statements/sagas';
import uploadSaga from './upload/sagas';
import downloadSaga from './download/sagas';
import exportSagas from './exports/sagas';
import fileGenerationSagas from './file-generation/sagas';

export default function* rootSaga(): Generator<any, void, any> {
  return yield all([
    auth(),
    statements(),
    uploadSaga(),
    downloadSaga(),
    exportSagas(),
    fileGenerationSagas(),
  ]);
}
